import { forwardRef, type Ref, type SVGProps } from "react";

function SvgHouse(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" {...props}>
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        d="M7.917 13.75v2.918H5.001c-.92 0-1.667-.747-1.667-1.667V8.378c0-.55.27-1.063.722-1.374l5-3.437a1.67 1.67 0 0 1 1.889 0l5 3.437c.452.311.722.825.722 1.374V15c0 .92-.746 1.667-1.666 1.667h-2.917V13.75a2.083 2.083 0 0 0-4.167 0Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgHouse);
export default ForwardRef;
